/**
 * Bold/SC swatch tooltips: inject option image on click or mouse over; remove on mouse leave.
 */
(function () {
	var TOOLTIP_IMAGE_CLASS = "sc-tooltip-option-image";
	var HOVER_DELAY_MS = 120;

	function getOptionImageSrc(valueEl) {
		var img = valueEl.querySelector(".bold_option_value_swatch img, .bold_option_value img, img");
		if (img && img.src) return img.src;
		var span = valueEl.querySelector(".bold_option_value_swatch span, .bold_option_value_swatch > span");
		if (span) {
			var bg = window.getComputedStyle(span).backgroundImage;
			var match = bg && bg.match(/url\(["']?([^"')]+)["']?\)/);
			if (match) return match[1];
		}
		return null;
	}

	function removeImageFromTooltip(valueEl) {
		var tooltip = valueEl.querySelector(".bold_option_swatch_title") || valueEl.querySelector(".bold_tooltip");
		if (!tooltip) return;
		var existing = tooltip.querySelector(".sc-tooltip-option-image-wrapper");
		if (existing) existing.remove();
	}

	function injectImageIntoTooltip(valueEl) {
		var tooltip = valueEl.querySelector(".bold_option_swatch_title") || valueEl.querySelector(".bold_tooltip");
		if (!tooltip) return;
		var src = getOptionImageSrc(valueEl);
		if (!src) return;

		var existing = tooltip.querySelector(".sc-tooltip-option-image-wrapper");
		if (existing) existing.remove();

		var wrapper = document.createElement("div");
		wrapper.className = "sc-tooltip-option-image-wrapper";
		wrapper.style.cssText = "max-width:120px;min-height:80px;";
		var tooltipImg = document.createElement("img");
		tooltipImg.className = TOOLTIP_IMAGE_CLASS;
		tooltipImg.src = src;
		tooltipImg.alt = "";
		tooltipImg.setAttribute("loading", "lazy");
		tooltipImg.style.cssText = "max-width:120px;max-height:120px;display:block;";
		wrapper.appendChild(tooltipImg);
		tooltip.insertBefore(wrapper, tooltip.firstChild);
	}

	function setupOptionValue(valueEl) {
		if (valueEl.dataset.scTooltipImageDone) return;
		valueEl.dataset.scTooltipImageDone = "1";
		var hoverTimer = null;

		valueEl.addEventListener("mouseenter", function () {
			hoverTimer = setTimeout(function () {
				hoverTimer = null;
				injectImageIntoTooltip(valueEl);
			}, HOVER_DELAY_MS);
		});
		valueEl.addEventListener("mouseleave", function () {
			if (hoverTimer) {
				clearTimeout(hoverTimer);
				hoverTimer = null;
			}
			removeImageFromTooltip(valueEl);
		});
		valueEl.addEventListener("click", function () {
			if (hoverTimer) {
				clearTimeout(hoverTimer);
				hoverTimer = null;
			}
			injectImageIntoTooltip(valueEl);
		});
	}

	function injectTooltipImage() {
		var values = document.querySelectorAll(".bold_option_swatch .bold_option_value");
		values.forEach(setupOptionValue);
	}

	function run() {
		injectTooltipImage();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			run();
			setTimeout(run, 1200);
		});
	} else {
		run();
		setTimeout(run, 1200);
	}
	document.addEventListener("shopify:section:load", run);
})();
